"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregationIntervalHelperByValueTypeId = void 0;
const _aggregation_helpers_1 = require("../../_aggregation_helpers");
exports.aggregationIntervalHelperByValueTypeId = {
    fruitGrowth: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
    fruitSize: _aggregation_helpers_1.defaultAggregationIntervalHelper,
    fruitSizeTarget: _aggregation_helpers_1.dailyOnlyAggregationIntervalHelper,
};
//# sourceMappingURL=fruit_growth.js.map